import Script from 'next/script';
import React, { useContext } from 'react';
import env from '../../env';
import { CookieConsentContext } from '../CookieConsent/CookieConsentProvider';
import { CookieConsentType } from '../CookieConsent/CookieConsentType';

const Orvesto = () => (
    <Script
        id="orvesto-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
            __html: `
    //orvesto
    var _cInfo = window._cInfo || [];
    (function() {
        if (document.cookie.match("__codnt") === null) {
            var ca = document.createElement('script');
            ca.type = 'text/javascript';
            ca.async = true;
            ca.src = 'https://analytics.codigo.se/j/36d7728b318c4ae98963619ca1a2ec23.js';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(ca, s);
        }
    })();`,
        }}
    />
);

const Dmp = () => (
    <>
        <Script
            strategy="lazyOnload"
            id="dmp-script"
            src="https://track.adform.net/serving/scripts/trackpoint/"
        />
        <noscript>
            <p style={{ margin: 0, padding: 0, border: 0 }}>
                <img
                    src="https://track.adform.net/Serving/TrackPoint/?pm=2204621&ADFPageName=SVTPlay&ADFdivider=|"
                    width="1"
                    height="1"
                    alt=""
                />
            </p>
        </noscript>
    </>
);

const LinkPulse = () => (
    <>
        <link rel="preconnect" href="http://pp.lp4.io" />
        <Script
            id="lp-script"
            strategy="lazyOnload"
            src="https://pp.lp4.io/app/53/86/37/53863755e45a1dcc20e7ad59.20180413132908.js"
        />
    </>
);

const ExternalScripts = () => {
    const { isOptedIn } = useContext(CookieConsentContext);

    return (
        <>
            {isOptedIn(CookieConsentType.STATISTICS) && (
                <>
                    <Orvesto />
                    {env.FLAG_ENABLE_LINKPULSE && <LinkPulse />}
                </>
            )}
            {isOptedIn(CookieConsentType.AD) && env.FLAG_ENABLE_DMP_TRACKING && <Dmp />}
        </>
    );
};

export default ExternalScripts;
